<template>
  <div class="tooltip-container">
  <span
  class="template-tooltip-span"
  v-accessible-tooltip="tooltipId"
      :role="role"
      :id="triggerId"
      :tabindex="isInteractive ? '0' : '-1'"
      :aria-label="ariaLabel || content"
      :aria-expanded="showTooltip ? 'true' : 'false'"
      @focus="isInteractive ? show : null"
      @blur="isInteractive ? handleBlur : null"
      @mouseenter="showWithDelay"
      @mouseleave="handleMouseLeave"
      @keydown.esc.prevent="isInteractive ? hide : null"
      @keydown.enter.prevent="isInteractive ? toggle : null"
      @keydown.space.prevent="isInteractive ? toggle : null"
    >
      <!-- If caller provides slot, use it as the trigger (for inline labels). Otherwise use a question mark button -->
      <slot>
        ?
      </slot>

      <md-tooltip
        :md-active.sync="showTooltip"
        md-direction="right"
        class="tool-tip-right v-tool-tip template-tool-tip md-tooltip-custom"
        :id="tooltipId"
        role="tooltip"
        @mouseenter="onTooltipEnter"
        @mouseleave="onTooltipLeave"
      >
        <span id="tooltip-content">{{ content }}</span>
      </md-tooltip>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    content: { type: String, required: true },
    ariaLabel: { type: String, default: '' },
    role: { type: String, default: 'img' },
    isInteractive: { type: Boolean, default: false },
    triggerId: {
      type: String,
      default() {
        return `tooltip-trigger-${Math.random().toString(36).substr(2, 9)}`;
      }
    }
  },
  data() {
    return {
      showTooltip: false,
      isHovering: false,
      showTimeout: null,
      hideTimeout: null,
      tooltipId: `tooltip-${Math.random().toString(36).substr(2, 9)}`
    };
  },
  methods: {
    toggle() {
      if (this.showTooltip) this.hide(); else this.show();
    },
    showWithDelay() {
      this.clearTimers();
      this.showTimeout = setTimeout(() => this.show(), 200);
    },
    show() {
      this.clearTimers();
      this.showTooltip = true;
      document.addEventListener('keydown', this.handleDocumentKeydown);
    },
    hideWithDelay() {
      this.clearTimers();
      this.hideTimeout = setTimeout(() => this.hide(), 200);
    },
    hide() {
      this.clearTimers();
      this.showTooltip = false;
      this.isHovering = false;
      document.removeEventListener('keydown', this.handleDocumentKeydown);
    },
    handleBlur() {
      // if hovering tooltip, keep it open
      this.hideWithDelay();
    },
    handleMouseLeave() {
      this.hideWithDelay();
    },
    onTooltipEnter() {
      this.isHovering = true;
      this.clearTimers();
    },
    onTooltipLeave() {
      this.isHovering = false;
      this.hideWithDelay();
    },
    handleDocumentKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.hide();
        const trigger = document.getElementById(this.triggerId);
        if (trigger) trigger.focus();
      }
    },
    clearTimers() {
      if (this.showTimeout) { clearTimeout(this.showTimeout); this.showTimeout = null; }
      if (this.hideTimeout) { clearTimeout(this.hideTimeout); this.hideTimeout = null; }
    }
  },
  beforeDestroy() {
    this.clearTimers();
    document.removeEventListener('keydown', this.handleDocumentKeydown);
  }
};
</script>

<style scoped>
  .tooltip-container{
    display: inline-block;
  }
  .md-tooltip-custom {
    font-size:10px !important;
    line-height:12px !important;
    font-family: Roboto !important;
    font-style: normal !important;
    font-weight: 300 !important;
    max-width: 320px;
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tooltip.vue